import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import { Wordmark } from "@/components/brand/Wordmark";
import { SocialLinks } from "@/components/marketing/SocialLinks";
import { BRAND_NAME } from "@/lib/brand";
import { preserveSearch } from "@/lib/nav";
import { useDesktopPlatform } from "@/lib/useDesktopPlatform";

// Documentation and legal routes stay reachable in every presentation mode.
// The waitlist preview changes conversion behavior, not the public site map.
export function Footer() {
  const { t } = useTranslation();
  const { search } = useLocation();
  const showDesktopDownload = useDesktopPlatform() !== "unknown";
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-5 py-10 sm:px-6 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-col gap-2.5">
          <Wordmark tile />
          <p className="font-mono text-[11px] text-subtle-foreground">
            © {year} {BRAND_NAME}.
          </p>
        </div>

        <div className="flex flex-col gap-4 md:items-end">
          <SocialLinks />
          <nav
            aria-label={t("footer.aria")}
            className="flex flex-wrap items-center gap-x-6 gap-y-2.5 text-sm text-muted-foreground"
          >
            {showDesktopDownload ? (
              <Link
                className="transition-colors duration-300 hover:text-foreground"
                to={preserveSearch("/download", search)}
              >
                {t("nav.download")}
              </Link>
            ) : null}
            <Link
              className="transition-colors duration-300 hover:text-foreground"
              to={preserveSearch("/product", search)}
            >
              {t("nav.product")}
            </Link>
            <Link
              className="transition-colors duration-300 hover:text-foreground"
              to={preserveSearch("/security", search)}
            >
              {t("nav.security")}
            </Link>
            <Link
              className="transition-colors duration-300 hover:text-foreground"
              to={preserveSearch("/about", search)}
            >
              {t("nav.about")}
            </Link>
            <Link
              className="transition-colors duration-300 hover:text-foreground"
              to={preserveSearch("/pricing", search)}
            >
              {t("nav.pricing")}
            </Link>
            <Link
              className="transition-colors duration-300 hover:text-foreground"
              to={preserveSearch("/contact", search)}
            >
              {t("footer.contact")}
            </Link>
            <Link
              className="transition-colors duration-300 hover:text-foreground"
              to={preserveSearch("/docs", search)}
            >
              {t("nav.docs")}
            </Link>
            <Link
              className="transition-colors duration-300 hover:text-foreground"
              to={preserveSearch("/legal/terms", search)}
            >
              {t("footer.terms")}
            </Link>
            <Link
              className="transition-colors duration-300 hover:text-foreground"
              to={preserveSearch("/legal/privacy", search)}
            >
              {t("footer.privacy")}
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
